<mat-sidenav-container #sidenavContainerRef class="sidenav-container" [autosize]="true">
  <mat-sidenav 
    [appSidenavAutosizeFix]="sidenavContainerRef"
    mode="side"
    opened
    [disableClose]="true"
    class="sidenav"
    [class.sidenav-expanded]="sidenavExpanded()" 
    [class.sidenav-contracted]="!sidenavExpanded()"
  >
    <app-navigation (sidenavToggled)="onSidenavToggled($event)" [initialState]="sidenavExpanded()" />
  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content">
    <header class="header">
      <app-header />
    </header>

    <main class="main">
      <router-outlet />
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>